// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.directive('prevent-enter', {
  inserted: function (el) {
    el.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault(); // 阻止默认的回车键行为
        console.log('Enter key is disabled globally');
      }
    });
  }
});
/**
 * 引入axios
 * 
 */
import axios from 'axios'
Vue.prototype.$axios = axios;

// import common from '../static/js/common'
// Vue.use(common)

Vue.config.productionTip = false

//自动获取焦点
Vue.directive('focus', function (el, option) {
  var defClass = 'el-input', defTag = 'input';
  var value = option.value || true;
  if (typeof value === 'boolean')
    value = { cls: defClass, tag: defTag, foc: value };
  else
    value = { cls: value.cls || defClass, tag: value.tag || defTag, foc: value.foc || false };
  if (el.classList.contains(value.cls) && value.foc)
    el.getElementsByTagName(value.tag)[0].focus();
});

/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js